module.exports = __webpack_public_path__ + "img/place-4.02e3cdf5.svg";